module.exports = __webpack_public_path__ + "img/ttm-main-1242.ffd928b1.jpg";